<template>
  <div class="market-pairs">
    <div class="tab-content" id="myTabContent">
      <div
        class="tab-pane fade show active"
        id="btc"
        role="tabpanel"
        aria-labelledby="btc-id"
      >
        <table class="table">
          <thead>
            <tr>
              <th style="border-top: none">Pairs</th>
              <th style="border-top: none">Last Price</th>
              <th style="border-top: none">Change</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="bi in biList"
              :key="bi.bi_id"
              @click="handleBiSelected(bi)"
              style="cursor: pointer"
            >
              <td>{{ bi.ename }}</td>
              <td class="text-left">{{ bi.price }}</td>
              <td :class="bi.rate > 0 ? 'blue' : 'red'">{{ bi.rate }}%</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    biList: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleBiSelected(bi) {
      console.log(bi);
      this.$emit("bi-selected", bi);
    },
  },
};
</script>
<style scoped>
.blue {
  color: blue;
}

.text-left {
  text-align: left !important;
  font-family: monospace;
  white-space: nowrap;
}

td {
  text-align: left;
}
</style>
